import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
  await OneSignal.init({ appId: 'f7469d1a-a951-4bd4-a21c-e9c434317fb0', allowLocalhostAsSecureOrigin: true});
  OneSignal.Slidedown.promptPush();
}